import { render, staticRenderFns } from "./billing-info-v2-summary.component.vue?vue&type=template&id=71330c78&scoped=true&"
import script from "./billing-info-v2-summary.component.vue?vue&type=script&lang=ts&"
export * from "./billing-info-v2-summary.component.vue?vue&type=script&lang=ts&"
import style0 from "./billing-info-v2-summary.component.vue?vue&type=style&index=0&id=71330c78&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71330c78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDivider,VIcon,VTooltip})
